import { render } from "./PigProgressCard.vue?vue&type=template&id=06d79680&scoped=true&ts=true"
import script from "./PigProgressCard.vue?vue&type=script&lang=ts"
export * from "./PigProgressCard.vue?vue&type=script&lang=ts"

import "./PigProgressCard.vue?vue&type=style&index=0&id=06d79680&scoped=true&lang=css"
import "./PigProgressCard.vue?vue&type=style&index=1&id=06d79680&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d79680"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTime from 'quasar/src/components/time/QTime.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QIcon,QSpace,QBtn,QTooltip,QMenu,QList,QItem,QItemSection,QToolbar,QForm,QBadge,QSelect,QInput,QPopupProxy,QDate,QTime,QSeparator,QCardActions,QToolbarTitle,QTable,QTd,QBtnDropdown,QItemLabel,QOptionGroup});qInstall(script, 'directives', {ClosePopup});
